module.exports = __webpack_public_path__ + "assets/Credit-Card-MasterCard.e07f4032.svg";